module.exports = __webpack_public_path__ + "img/lk_type_res.f5d8f69b.svg";